import {ColumnsConfig} from '../../../overtimeReport/ColumnsConfig'
import OvertimeHTMLPreviewHeaderSection from './OvertimeHTMLPreviewHeaderSection'
import OvertimeHTMLPreviewGroupingSection from './OvertimeHTMLPreviewGroupingSection'

export default function OvertimeHTMLPreviewGenerator() {}

OvertimeHTMLPreviewGenerator.prototype.init = function() {
    return this
}

OvertimeHTMLPreviewGenerator.prototype.generatePreviewTable = function(reportParameters) {
    const table = document.createElement("table")
    table.className = "reportHtmlPreviewTable overtime" + (EnabledFeatures.LVT ? "" : " lvtDisabled")
    const tBody = document.createElement("tbody")
    table.appendChild(tBody)

    const hasTimeBalance = reportParameters.columnsConfig !== ColumnsConfig.OVERTIME_ONLY
    const hasOvertime = reportParameters.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY
    const showWorkingAndLeaveTime = reportParameters.showWorkingAndLeaveTime

    const headerSection = new OvertimeHTMLPreviewHeaderSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        hasTimeBalance,
        hasOvertime,
        showWorkingAndLeaveTime,
    )

    const groupingSection = new OvertimeHTMLPreviewGroupingSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.timeFormat,
        hasTimeBalance,
        hasOvertime,
        showWorkingAndLeaveTime,
    )

    headerSection.addRows(tBody)
    groupingSection.addRows(tBody)

    return table
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/overtime/OvertimeHTMLPreviewGenerator.js